import store from '@/store'
import { ESmartBarcodeMenu } from '@/utils/enums'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
    meta: {
      header: {
        logo: false,
      },
      restricted: false,
    },
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import(/* webpackChunkName: "forgot-password" */ '@/views/ForgotPassword.vue'),
    meta: {
      header: {
        logo: false,
      },
      restricted: false,
    },
  },
  {
    path: '/new-password',
    name: 'new-password',
    component: () => import(/* webpackChunkName: "new-password-set" */ '@/views/ForgotPassword.vue'),
    meta: {
      header: {
        logo: false,
      },
      restricted: false,
    },
  },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
    meta: {
      restricted: true,
    },
  },
  {
    path: '/timetable',
    name: 'timetable',
    component: () => import('@/views/TimeTable.vue'),
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.TIMETABLE,
    },
    beforeEnter: (to, from, next) => {
      store.getters.isEnableTimetable
        ? next()
        : next({
            name: 'home',
          })
    },
  },
  {
    path: '/marumiya-products',
    name: 'marumiya-products',
    component: () => import(/* webpackChunkName: "marumiya-products" */ '@/views/MarumiyaProducts.vue'),
    meta: {
      menuKey: ESmartBarcodeMenu.MARUMIYA_PRODUCTS,
      restricted: true,
    },
    beforeEnter: (to, from, next) => {
      next()
    },
  },
  {
    path: '/suppliers',
    name: 'suppliers',
    component: () => import(/* webpackChunkName: "suppliers" */ '@/views/Suppliers.vue'),
    meta: {
      menuKey: ESmartBarcodeMenu.SUPPLIERS,
      restricted: true,
    },
    beforeEnter: (to, from, next) => {
      next()
    },
  },
  {
    path: '/work-centers',
    name: 'work-centers',
    component: () => import(/* webpackChunkName: "workcenters" */ '@/views/Workcenters.vue'),
    meta: {
      menuKey: ESmartBarcodeMenu.WORK_CENTERS,
      restricted: true,
    },
    beforeEnter: (to, from, next) => {
      next()
    },
  },
  {
    path: '/warehouses',
    name: 'warehouses',
    component: () => import(/* webpackChunkName: "warehouses" */ '@/views/Warehouses.vue'),
    meta: {
      menuKey: ESmartBarcodeMenu.WAREHOUSES,
      restricted: true,
    },
    beforeEnter: (to, from, next) => {
      next()
    },
  },
  // {
  //   path: '/conversion-factors',
  //   name: 'conversion-factors',
  //   component: () => import(/* webpackChunkName: "conversion-factors" */ '@/views/ConversionFactor.vue'),
  //   meta: {
  //     menuKey: ESmartBarcodeMenu.CONVERSION_FACTORS,
  //     restricted: true,
  //   },
  //   beforeEnter: (to, from, next) => {
  //     next()
  //   },
  // },
  {
    path: '/mo',
    name: 'manufacturing-plan',
    component: () => import(/* webpackChunkName: "manufacturing-plan" */ '@/views/ManufacturingPlan.vue'),
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.MANUFACTURING_PLAN,
    },
    beforeEnter: (to, from, next) => {
      next()
    },
  },
  {
    path: '/mo/:id',
    name: 'mo-detail',
    component: () => import(/* webpackChunkName: "mo-detail" */ '@/views/ManufacturingPlanDetail.vue'),
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.MANUFACTURING_PLAN,
    },
    props: true,
  },
  {
    path: '/serial',
    name: 'serial',
    component: () => import(/* webpackChunkName: "serial" */ '@/views/Serial.vue'),
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.SERIAL,
    },
    beforeEnter: (to, from, next) => {
      next()
    },
  },
  {
    path: '/serial/:id',
    name: 'serial-detail',
    component: () => import(/* webpackChunkName: "serial-detail" */ '@/views/SerialDetail.vue'),
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.SERIAL,
    },
    props: true,
  },
  {
    path: '/user-group',
    name: 'userGroup',
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.CARRIER,
    },
    component: () => import(/* webpackChunkName: "projectEdit" */ '@/components/carrier/UserGroup.vue'),
    props: true,
  },
  {
    path: '/user-group/add',
    name: 'userGroupCreate',
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.CARRIER,
    },
    component: () => import(/* webpackChunkName: "projectEdit" */ '@/components/carrier/UserGroupForm.vue'),
    props: true,
  },
  {
    path: '/user-group/edit/:id',
    name: 'userGroupEdit',
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.CARRIER,
    },
    component: () => import(/* webpackChunkName: "projectEdit" */ '@/components/carrier/UserGroupForm.vue'),
    props: true,
  },
  {
    path: '/address-book',
    name: 'address-book',
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.ADDRESS_BOOK,
    },
    component: () => import(/* webpackChunkName: "address-book" */ '@/views/AddressBook.vue'),
  },
  {
    path: '/address-book/edit',
    name: 'address-book-detail',
    component: () => import(/* webpackChunkName: "address-book-detail" */ '@/views/AddressBookDetail.vue'),
    props: true,
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.ADDRESS_BOOK,
    },
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "product" */ '@/views/Product.vue'),
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.PRODUCT,
    },
  },
  {
    path: '/product/edit',
    name: 'product-detail',
    component: () => import(/* webpackChunkName: "product-detail" */ '@/views/ProductDetail.vue'),
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.PRODUCT,
    },
  },
  {
    path: '/permission',
    name: 'permission',
    component: () => import(/* webpackChunkName: "permission" */ '@/views/Permission.vue'),
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.PERMISSION,
    },
  },
  {
    path: '/barcode/search',
    name: 'barcodeSearch',
    component: () => import('@/views/Barcode.vue'),
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.BARCODE_SEARCH,
    },
  },
  {
    path: '/barcode/:id',
    name: 'barcodeView',
    component: () => import('@/components/barcode/BarcodeDetail.vue'),
    meta: {
      restricted: true,
      menuKey: ESmartBarcodeMenu.BARCODE_SEARCH,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import(/* webpackChunkName: "notFound" */ '@/components/common/NotFound.vue'),
    meta: {
      header: {
        logo: false,
        homeButtton: true,
      },
      restricted: false,
    },
    props: true,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
